import { api_payment_info_path, api_update_payment_path } from '../../routes';
import request from './request';

export interface UpdatePaymentParams {
  jwt?: string;
}

export interface UpdatePaymentResponse {
  redirect_to: string;
}

export interface PaymentInfoProps {
  billingAmount: string;
  billingDate: string;
  creditCardLast4Digits?: string;
  isUserPastDue: boolean;
  paymentType: string;
  stripeCustomerId: string;
}

export async function fetchPaymentInfo(): Promise<PaymentInfoProps> {
  const response = await request('get', api_payment_info_path());
  return response;
}

export async function updatePayment(): Promise<UpdatePaymentResponse> {
  const response = await request('post', api_update_payment_path());
  return response;
}
